import React from 'react';
import PropTypes from 'prop-types';

// we need to use a tags for now until we fully migrate all routes in app.v4
// react-router-dom's Link wont allow us to access app.v4 routes
// import { Link } from 'react-router-dom';
import styled from 'styled-components';

// const ModalFooterLink = styled(Link)`
const StyledModalFooterLink = styled.a`
  font-weight: 500;
  font-style: normal;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  color: #0095ff !important;
  text-decoration: underline !important;

  &:hover {
    color: #0077cc !important;
    text-decoration: underline !important;
  }

  &:active {
    color: #0068b3 !important;
  }
`;

const ModalFooterLink = ({ to, children, ...rest }) => {
  return (
    <StyledModalFooterLink href={to} {...rest}>
      {children}
    </StyledModalFooterLink>
  );
};

ModalFooterLink.propTypes = {
  to: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};

export default ModalFooterLink;
